export const articles = [
  {
    id: 1,
    slug: "kakobuy-spreadsheet-kompletny-przewodnik",
    title: "Kakobuy Spreadsheet Polska — Kompletny przewodnik 2026",
    excerpt: "Dowiedz się wszystkiego o Kakobuy Spreadsheet w Polsce. Największa baza produktów, gotowe linki i poradnik zakupowy dla początkujących.",
    image: "https://readdy.ai/api/search-image?query=Flat%20lay%20fashion%20shopping%20spreadsheet%20with%20sneakers%20hoodies%20and%20accessories%20on%20clean%20cream%20desk%20minimal%20aesthetic%20warm%20morning%20natural%20lighting%20editorial%20photography%20high%20detail%20soft%20shadows&width=800&height=500&seq=article-v2-01&orientation=landscape&nocache=true",
    category: "Przewodnik",
    readTime: "8 min",
    date: "2026-07-16",
  },
  {
    id: 2,
    slug: "kakobuy-spreadsheet-najlepsze-produkty",
    title: "Kakobuy Spreadsheet Najlepsze Produkty — Top 50 znalezisk 2026",
    excerpt: "Lista 50 najlepszych produktów w Kakobuy Spreadsheet wybranych przez społeczność. Sprawdzone linki, opinie i zdjęcia QC.",
    image: "https://readdy.ai/api/search-image?query=Premium%20streetwear%20collection%20display%20sneakers%20hoodies%20jackets%20on%20light%20wooden%20shelves%20warm%20ambient%20afternoon%20lighting%20minimal%20ecommerce%20photography%20clean%20aesthetic%20organized&width=800&height=500&seq=article-v2-02&orientation=landscape&nocache=true",
    category: "Ranking",
    readTime: "10 min",
    date: "2026-07-14",
  },
  {
    id: 3,
    slug: "kakobuy-bezpieczenstwo-zakupow",
    title: "Czy Kakobuy jest bezpieczny? Kompletny poradnik 2026",
    excerpt: "Wszystko co musisz wiedzieć o bezpieczeństwie zakupów na Kakobuy. Jak unikać oszustw, sprawdzać sprzedawców i chronić swoje pieniądze.",
    image: "https://readdy.ai/api/search-image?query=Secure%20online%20shopping%20concept%20with%20padlock%20and%20shopping%20bags%20on%20clean%20minimal%20cream%20background%20warm%20neutral%20tones%20soft%20lighting%20editorial%20photography%20trust%20aesthetic&width=800&height=500&seq=article-v2-03&orientation=landscape&nocache=true",
    category: "Bezpieczeństwo",
    readTime: "6 min",
    date: "2026-07-12",
  },
  {
    id: 4,
    slug: "jak-korzystac-z-kakobuy",
    title: "Jak korzystać z Kakobuy — Poradnik dla absolutnie początkujących",
    excerpt: "Nigdy nie korzystałeś z Kakobuy? Ten przewodnik wyjaśni Ci wszystko od podstaw. Rejestracja, pierwsze zamówienie, śledzenie paczki.",
    image: "https://readdy.ai/api/search-image?query=Person%20using%20laptop%20browsing%20online%20store%20modern%20minimal%20workspace%20clean%20light%20wood%20desk%20coffee%20cup%20warm%20golden%20hour%20light%20editorial%20lifestyle%20photography%20cozy&width=800&height=500&seq=article-v2-04&orientation=landscape&nocache=true",
    category: "Tutorial",
    readTime: "7 min",
    date: "2026-07-10",
  },
];